import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/dataAnalysis',
  component: layout,
  children: ((pre) => [
    {
      path: 'resourceContribution',
      name: `${pre}resourceContribution`,
      meta: {
        ...meta,
        cache: true,
        title: '资源贡献度分析月报',
        head: true,
        funcID: 'T000801',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/resourceContribution')
    },
    {
      path: 'resourceUsage',
      name: `${pre}resourceUsage`,
      meta: {
        ...meta,
        cache: true,
        title: '素材资源使用率排名',
        head: true,
        funcID: 'T000802',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/resourceUsage')
    },
    {
      path: 'resourceInfoUsage',
      name: `${pre}resourceInfoUsage`,
      meta: {
        ...meta,
        cache: true,
        title: '市场情报使用率排名',
        head: true,
        funcID: 'T000803',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/resourceInfoUsage')
    },
    {
      path: 'supplierResource',
      name: `${pre}supplierResource`,
      meta: {
        ...meta,
        cache: true,
        title: '供应链情报资源统计',
        head: true,
        funcID: 'T000804',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/supplierResource')
    },
    {
      path: 'projectOverall',
      name: `${pre}projectOverall`,
      meta: {
        ...meta,
        cache: true,
        title: '项目整体情况分析',
        head: true,
        funcID: 'T000805',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/projectOverall')
    },
    {
      path: 'projectInfo',
      name: `${pre}projectInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '项目情况一览分析',
        head: true,
        funcID: 'T000806',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/projectInfo')
    },
    {
      path: 'projectSample',
      name: `${pre}projectSample`,
      meta: {
        ...meta,
        cache: true,
        title: '项目相关打样记录统计',
        head: true,
        funcID: 'T000807',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/projectSample')
    },
    {
      path: 'scmVisit',
      name: `${pre}scmVisit`,
      meta: {
        ...meta,
        cache: true,
        title: '供应商拜访记录统计',
        head: true,
        funcID: 'T000808',
        PID: 'T00'
      },
      component: () => import('@/views/digital/dataAnalysis/scmVisit')
    }
  ])('dataAnalysis-')
}
